"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceConnectorMock = exports.handleMobileRequest = exports.isMobileCommunicatorMockMode = void 0;
/* eslint-disable no-console */
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const messages_1 = require("./messages");
const messagesV2_1 = require("./messagesV2");
var developmentMobileCommunicator_1 = require("../developmentTools/developmentMobileCommunicator");
Object.defineProperty(exports, "isMobileCommunicatorMockMode", { enumerable: true, get: function () { return developmentMobileCommunicator_1.isMobileCommunicatorMockMode; } });
const MessageMapper = (session) => ({
    [messages_1.MESSAGES.TYPE_ACCESS_TOKEN.key]: (deviceConnector, type) => {
        const accessToken = session.getData()?.accessToken;
        return deviceConnector.sendEventFromMockedMobile(type, accessToken);
    },
    [messages_1.MESSAGES.TYPE_REFRESH_TOKEN.key]: (deviceConnector, type) => {
        const accessToken = session.getData()?.accessToken;
        return deviceConnector.sendEventFromMockedMobile(type, accessToken);
    },
    [messages_1.MESSAGES.TYPE_DEVICE_INFO.key]: (deviceConnector, type) => {
        const mockDeviceInfoResponse = '{"top_margin": 0, "dark_mode": false}';
        return deviceConnector.sendEventFromMockedMobile(type, mockDeviceInfoResponse);
    },
    [messages_1.MESSAGES.TYPE_GO_BACK.key]: (deviceConnector, type) => {
        history.back();
        return deviceConnector.sendEventFromMockedMobile(type, undefined);
    },
    [messages_1.MESSAGES.TYPE_OPEN_WEB_BROWSER.key]: (deviceConnector, type, data) => {
        const targetBlank = '_blank';
        window.open(data, targetBlank);
        return deviceConnector.sendEventFromMockedMobile(type, undefined);
    },
});
const MessageMappeV2 = (session) => ({
    [messagesV2_1.MESSAGES.TYPE_ACCESS_TOKEN.key]: (deviceConnector, type) => {
        const accessToken = session.getData()?.accessToken;
        return deviceConnector.sendEventFromMockedMobile(type, accessToken);
    },
    [messagesV2_1.MESSAGES.TYPE_OPEN_WEB_BROWSER.key]: (deviceConnector, type, data) => {
        const targetBlank = '_blank';
        window.open(data, targetBlank);
        return deviceConnector.sendEventFromMockedMobile(type, undefined);
    },
    [messagesV2_1.MESSAGES.TYPE_FETCH.key]: (deviceConnector, type, data) => {
        const { url, method, headers, body } = data;
        return deviceConnector.sendEventFromMockedMobile(type, { url, method, headers, body });
    },
});
const handleMobileRequest = async (deviceConnector, type, data, session, mobileConnectorConfig, version) => {
    console.log('handleMobileRequest - Resolved message', type, data);
    const messageMapper = version ? MessageMappeV2(session) : MessageMapper(session);
    if (messageMapper[type]) {
        return messageMapper[type](deviceConnector, type, data);
    }
    if (mobileConnectorConfig?.mockedMessage) {
        const verticalMockedMessage = await mobileConnectorConfig.mockedMessage(type, data);
        return deviceConnector.sendEventFromMockedMobile(type, verticalMockedMessage);
    }
    return null;
};
exports.handleMobileRequest = handleMobileRequest;
const getDeviceConnectorMock = (session, mobileConnectorConfig, version) => new web_ui_framework_1.DevelopmentDeviceConnector((deviceConnector, type, data) => (0, exports.handleMobileRequest)(deviceConnector, type, data, session, mobileConnectorConfig, version), []);
exports.getDeviceConnectorMock = getDeviceConnectorMock;
//# sourceMappingURL=mock.js.map